import { FULL_HD, HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { getFont } from '@tornado-rdk/typography';
import { HEIGHT as INCENTIVE_HEIGHT } from '../incentive/incentive.style';
import {
  TITLE_FONT_NAME,
  TITLE_FONT_TYPE,
  DESCRIPTION_FONT_NAME,
  DESCRIPTION_FONT_TYPE,
  ITEMS_BY_BREAKPOINTS,
} from './customer/default/squareMeta.constants';
import { getElementSize } from '../utils/sizes';

export * from './customer/default/squareMeta.constants';

export const IMAGE_MARGIN_BOTTOM = 8;

export const ICON_PADDING_VERTICAL = 4;

export const ICON_PADDING_HORIZONTAL = 8;

export const ICON_HEIGHT = {
  [HD]: 24,
  [FULL_HD]: 32,
};

export const TITLES_ORDER = ['Title', 'Description'];

export const TITLE_LINES = 2;

export const DESCRIPTION_LINES = 2;

export const templates = {
  SquareMeta: 'SquareMeta',
};
const RATIO = 1;

const metadataHeight = {
  [HD]:
    INCENTIVE_HEIGHT[HD] +
    getFont(TITLE_FONT_NAME, HD, TITLE_FONT_TYPE).lineHeight * TITLE_LINES +
    getFont(DESCRIPTION_FONT_NAME, HD, DESCRIPTION_FONT_TYPE).lineHeight * DESCRIPTION_LINES +
    IMAGE_MARGIN_BOTTOM,
  [FULL_HD]:
    INCENTIVE_HEIGHT[FULL_HD] +
    getFont(TITLE_FONT_NAME, FULL_HD, TITLE_FONT_TYPE).lineHeight * TITLE_LINES +
    getFont(DESCRIPTION_FONT_NAME, FULL_HD, DESCRIPTION_FONT_TYPE).lineHeight * DESCRIPTION_LINES +
    IMAGE_MARGIN_BOTTOM,
};
const { imageOptions } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.SquareMeta);

export { imageOptions };

const buildSizes = context => ({
  [HD]: {
    w: imageOptions[templates.SquareMeta][context][HD].PRIMARY.width,
    h: imageOptions[templates.SquareMeta][context][HD].PRIMARY.height + metadataHeight[HD],
  },
  [FULL_HD]: {
    w: imageOptions[templates.SquareMeta][context][FULL_HD].PRIMARY.width,
    h: imageOptions[templates.SquareMeta][context][FULL_HD].PRIMARY.height + metadataHeight[FULL_HD],
  },
});

export const sizes = {
  [templates.SquareMeta]: {
    [RENDERING_CONTEXT.GENERAL]: buildSizes(RENDERING_CONTEXT.GENERAL),
    [RENDERING_CONTEXT.SEARCH]: buildSizes(RENDERING_CONTEXT.SEARCH),
  },
};
